<template>
    <div>
        <!-- 过滤条件 -->
        <div
            :class="preCls + 'filter'"
            style="display: flex; align-items: center; margin-bottom: 4px"
        >
            <form-lookup
                style="
                    min-width: 262px;
                    margin-right: 15px;
                    max-height: 90px;
                    overflow: auto;
                "
                v-model="selectRoom.roomId"
                :options.sync="selectRoom.roomList"
                placeholder="房源名称"
                title="选择房间"
                textSymbol="title"
                valueSymbol="id"
                :modalHeight="600"
                :modalWidth="900"
                @change="onSelectRoom"
                @clear="onClearRoom"
                @deselect="onDeselectRoom"
            >
                <select-room multiple />
            </form-lookup>
            <!-- 选择排序 -->
            <Select
                style="width: 200px; margin-right: 15px"
                v-model="filter.orderBys"
                placeholder="排序类型"
                @on-change="search"
            >
                <Option
                    v-for="item in orderBysList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>
            <!-- 高级搜索 -->
            <bill-adv-search
                ref="adv"
                v-model="advFilter"
                :name="accessName"
                @confirm="onAdvConfirm"
            ></bill-adv-search>
        </div>
        <!-- 已选中的搜索条件 -->
        <select-tags
            v-model="advOptions"
            style="margin-bottom: 4px"
            @close="onAdvItemClose"
        ></select-tags>
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    v-model="filter.cusUser"
                    placeholder="请输入客户姓名,手机号或单位名称"
                    style="margin-left: 10px"
                    @search="search"
                ></table-searcher>
            </template>
            <Button
                v-if="$can('exportExcel')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                :loading="loadingExport"
                @click="onClickExport"
            >
                导出Excel
            </Button>
        </table-tool-bar>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
        >
            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button
                    v-if="$can('view')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickView(row)"
                >
                    详情
                </Button>
                <Button
                    v-if="row.feeType === '6' && $can('migrate')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickAddrMigrate(row)"
                >
                    地址迁移
                </Button>
                <Button
                    v-if="row.isViewContract && $can('viewContract')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="contractView(row)"
                >
                    查看合同
                </Button>
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch"
        ></table-pager>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showAddrMigrateForm"
            title="地址迁移"
            :width="800"
            :height="360"
            :maskClosable="false"
            @close-by-confirm="search"
        >
            <bill-addr-migrate-form
                v-if="modal.showAddrMigrateForm"
                :contractId="contractId"
                :migrate="migrate"
            />
        </smart-modal>
        <smart-modal
            v-model="modal.showBillForm"
            :title="actionTitle + '账单'"
            :width="800"
            :height="600"
            :maskClosable="false"
            @close-by-confirm="search"
        >
            <bill-form
                v-if="modal.showBillForm"
                :id="curId"
                :depositOffset="depositOffset"
                :offsetAmount="offsetAmount"
                billStatus="5"
                :actionType="actionType"
            />
        </smart-modal>
    </div>
</template>
<script>
import { mapCache } from '@/plugins/vux-data-cache'
import { pipeCell } from '_c/grid/renderCell'
import { currency, ymd } from '_u/helper'
import { getResAmountText, renderAmountText } from '@/views/common/u-contract'

import mBillList from '_v/common/m-bill-list'
import SelectRoom from '_vc/select-room'
import TagStatus from '_vc/tag-status'
import BillForm from './bill-form'
import BillAddrMigrateForm from './bill-addr-migrate-form'
import FilterDateRange from '_v/components/filter/filter-date-range'

import { billList } from '@/api/bill'
import { queryUserName } from '@/api/sys-user'

export default {
    name: 'bill-zf-list',
    mixins: [mBillList],
    components: {
        SelectRoom,
        TagStatus,
        BillForm,
        BillAddrMigrateForm,
        FilterDateRange,
    },
    data() {
        return {
            mtHeight: 360,
            loading: false,
            loadingExport: false,
            curId: '',
            contractId: '',
            page: {
                total: 0,
                list: [],
            },
            migrate: '', // 是否迁移
            depositOffset: '', // 定金抵扣方式
            offsetAmount: '', // 定金金额
            actionType: '', // 1 新增; 2 查看; 3 修改;
            modal: {
                showBillForm: false,
                showAddrMigrateForm: false,
            },

            dict: {
                billStatus: this.$dict.NULL,
                feeType: this.$dict.NULL,
                actionType: this.$dict.NULL,
            },
        }
    },
    computed: {
        ...mapCache({
            filter: 'zfFilter',
            advFilter: 'zfAdvFilter',
            advOptions: 'zfAdvOptions',
            selectRoom: 'zfSelectRoom',
        }),

        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 60,
                },
                {
                    key: 'houseName',
                    title: '房源名称',
                    align: 'left',
                    minWidth: 160,
                    tooltip: true,
                },
                {
                    key: 'cusUser',
                    title: '客户姓名',
                    align: 'left',
                    minWidth: 100,
                    tooltip: true,
                },
                {
                    key: 'cusMobile',
                    title: '客户手机号',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    key: 'comName',
                    title: '单位名称',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    key: 'feeTypeText',
                    title: '费用类型',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    key: 'periodText',
                    title: '当前账期',
                    align: 'center',
                    minWidth: 240,
                },
                {
                    key: 'receivable',
                    title: '应收金额(元)',
                    align: 'right',
                    minWidth: 150,
                    render: (h, params) => {
                        const list = params.row.receivable.split('\r\n')
                        return renderAmountText(h, list, 'div', 'div')
                    },
                },
                {
                    key: 'received',
                    title: '已收金额(元)',
                    align: 'right',
                    minWidth: 120,
                },
                {
                    key: 'payable',
                    title: '应付金额(元)',
                    align: 'right',
                    minWidth: 150,
                    render: (h, params) => {
                        const list = params.row.payable.split('\r\n')
                        return renderAmountText(h, list, 'div', 'div')
                    },
                },
                {
                    key: 'paid',
                    title: '已付金额(元)',
                    align: 'right',
                    minWidth: 120,
                },
                {
                    key: 'invalidTime',
                    title: '作废时间',
                    align: 'center',
                    width: 160,
                    render: pipeCell('ymdL'),
                },
                {
                    key: 'updateUserName',
                    title: '操作人',
                    align: 'left',
                    width: 120,
                },
                {
                    title: '操作',
                    align: 'center',
                    width: 240,
                    slot: 'action',
                    fixed: 'right',
                },
            ]
        },

        actionTitle() {
            return this.dict.actionType.val(this.actionType)
        },
    },
    created() {
        this.fetch()
    },
    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },
    methods: {
        fetch() {
            this.loading = true

            Promise.all([
                this.$dict.get(['bill_status', 'fee_type', 'action_type']),
                queryUserName(),
                billList(
                    Object.assign(
                        {},
                        this.filter,
                        this.normalizeAdvFilter(this.advFilter)
                    )
                ),
            ])
                .then((args) => {
                    var [group, users, view] = args

                    Object.assign(this.dict, group)

                    if (users) {
                        this.userNameMap = this.normalizeUserName(users.data)
                    }

                    if (view.data.page) {
                        this.page.list = this.normalizePageData(
                            view.data.page.list
                        )
                        this.page.total = parseInt(view.data.page.totalCount)
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        search() {
            this.filter.pageNo = 1
            this.fetch()
        },
        normalizePageData(list) {
            const billStatusDict = this.dict.billStatus
            const feeTypeDict = this.dict.feeType

            list.forEach((v) => {
                v.periodText = ''
                if (v.period && v.startDate && v.endDate) {
                    v.periodText = `第${v.period}期(${v.startDate} 至 ${v.endDate})`
                }
                v.planAmount =
                    currency(v.planAmount / 100) + getResAmountText(v)
                v.realAmount = currency(v.realAmount / 100)
                v.feeTypeText = feeTypeDict.val(v.feeType)
                v.receivable = v.planAmount
                v.received = v.realAmount
                v.payable = v.planAmount
                v.paid = v.realAmount
                v.updateTime = ymd(v.updateTime)
                // 是否可以查看合同（只有定金且未签合同才不显示）
                v.isViewContract =
                    !v.contractId && v.feeType === '14' ? false : true
                v.updateUserName = this.userNameMap[v.updateUserId] || ''
            })

            return list
        },
        // 导出Excel
        onClickExport() {
            this.loadingExport = true

            billList(
                Object.assign(
                    {},
                    this.filter,
                    this.normalizeAdvFilter(this.advFilter),
                    {
                        pageNo: 1,
                        pageSize: 99999,
                    }
                )
            )
                .then((res) => {
                    var $mt = this.$refs.mt
                    $mt.exportToExcel({
                        rows: this.normalizePageData(res.data.page.list),
                    })
                })
                .finally(() => {
                    this.loadingExport = false
                })
        },
        // 详情
        rowClickView(row) {
            this.actionType = '2'
            this.curId = row.id
            this.depositOffset = row.depositOffset
            this.offsetAmount = row.offsetAmount
            this.modal.showBillForm = true
        },
        // 地址迁移
        rowClickAddrMigrate(row) {
            this.contractId = row.contractId
            this.migrate = row.migrate
            this.modal.showAddrMigrateForm = true
        },
        // 查看合同
        contractView(row) {
            this.$router.push({
                name: 'contractViewIndex',
                query: { contractId: row.contractId, type: '5' },
            })
        },
    },
}
</script>
<style lang="less" scoped></style>
